module.exports = __webpack_public_path__ + "img/disconnected-icon.4d5a06f7.svg";